export const useTrophiesActionPopin = (waitBeforePlay: number = 500) => {
  const dialogTrophyFromHeader = useDialogTrophyFromHeader();

  const { hasHighlightedItems, ids, clear } = useTrophiesHeader();

  const { onActionHook, complete } = useActionHook(
    'popinTrophies',
    false,
    -1,
    [],
    waitBeforePlay
  );

  onActionHook(async () => {
    if (!hasHighlightedItems.value) {
      return complete(false);
    }

    await dialogTrophyFromHeader.open(ids.value);

    clear();

    complete(true);
  });
};
